import { action, makeObservable, observable } from "mobx"

import type { LandingActivityRow } from "@/domains/landing-page/interfaces"

/**
 * Holds the most recent on-chain activity rows (indexer-backed) shown in the
 * homepage live-activity ticker. The data is pushed in by an OrchestratedQuery
 * wired in ScaleApp; the store stays thin and presentation-agnostic.
 */
export class LiveActivityStore {
  rows: LandingActivityRow[] = []

  constructor() {
    makeObservable(this, {
      rows: observable,
      updateRows: action,
    })
  }

  updateRows(rows: LandingActivityRow[]): void {
    this.rows = rows
  }
}
